export default __webpack_public_path__ + "static/media/postgres.5d66de07.png";